"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlyoutCatalog = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flyout = require("../Flyout");
var _FlyoutCatalogBody = require("./FlyoutCatalogBody");
var FlyoutCatalog = function FlyoutCatalog(_ref) {
  var catalog = _ref.catalog,
    catalogLinks = _ref.catalogLinks,
    className = _ref.className,
    deviceType = _ref.deviceType,
    dataAttributes = _ref.dataAttributes,
    label = _ref.label,
    onFlyoutOpen = _ref.onFlyoutOpen,
    onLinkClick = _ref.onLinkClick,
    coreAssortmentTooltipText = _ref.coreAssortmentTooltipText;
  var renderContent = function renderContent(closeFlyout) {
    return /*#__PURE__*/_react["default"].createElement(_FlyoutCatalogBody.FlyoutCatalogBody, {
      catalog: catalog,
      deviceType: deviceType,
      catalogLinks: catalogLinks,
      closeFlyout: closeFlyout,
      onLinkClick: onLinkClick,
      coreAssortmentTooltipText: coreAssortmentTooltipText
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_Flyout.Flyout, {
    className: className,
    dataAttributes: dataAttributes,
    label: label,
    onFlyoutOpen: onFlyoutOpen,
    renderContent: renderContent
  });
};
exports.FlyoutCatalog = FlyoutCatalog;